export const stores = [
  {
    id: 1,
    title: "Ipermercati Finiper",
    address: "VIA BRUSAPORTO, 41, 20129 SERIATE (BG)",
    coordinates: { lat: 45.6833, lng: 9.7167 },
  },
  {
    id: 2,
    title: "Ipercoop Alleanza 3.0",
    address: "VIA PO, 1 - LOCALITA' SAMBUCETO, 40050 SAN GIOVANNI TEATINO (CH)",
    coordinates: { lat: 42.4167, lng: 14.2 },
  },
  {
    id: 3,
    title: "Conad Nor Ovest",
    address: "VIA BERNABEI 4A, 51100 MONTEPULCIANO (SI)",
    coordinates: { lat: 43.1, lng: 11.7833 },
  },
  {
    id: 4,
    title: "Conad Nor Ovest",
    address: "VIA MASSETANA, 58, 51100 SIENA (SI)",
    coordinates: { lat: 43.3188, lng: 11.3308 },
  },
  {
    id: 5,
    title: "Conad Nor Ovest",
    address: "VIA DELLE PROVINCE 2/A LOC. FONTEBECCI, 51100 SIENA (SI)",
    coordinates: { lat: 43.3188, lng: 11.3308 },
  },
  {
    id: 6,
    title: "Conad Nor Ovest",
    address: "VIA SENESE ARETINA, 79/81, 51100 CASTIGLION FIORENTINO (AR)",
    coordinates: { lat: 43.35, lng: 11.9167 },
  },
  {
    id: 7,
    title: "Conad Nor Ovest",
    address: "VIA MASSON - ANG. VIA LIVINI, 51100 COLLE DI VAL D'ELSA (SI)",
    coordinates: { lat: 43.4167, lng: 11.1333 },
  },
  {
    id: 8,
    title: "Panorama-Pam Destinazione",
    address: "STR.PROV.PER S. GIMINIANO, 30038 BARBERINO VAL D'ELSA (FI)",
    coordinates: { lat: 43.5333, lng: 11.1667 },
  },
  {
    id: 9,
    title: "Panorama-Pam Destinazione",
    address: "LOC. QUERCE AL PINO, 30038 CHIUSI (SI)",
    coordinates: { lat: 43.0167, lng: 11.95 },
  },
  {
    id: 10,
    title: "Ipercoop Distretto Nord Ovest",
    address: "VIA VARIANTE CISA, 40, 20090 SARZANA (SP)",
    coordinates: { lat: 44.1167, lng: 9.9667 },
  },
  {
    id: 11,
    title: "Ipermercati Finiper",
    address: "VIA NOVI, 39, 20129 SERRAVALLE SCRIVIA (AL)",
    coordinates: { lat: 44.7167, lng: 8.85 },
  },
  {
    id: 12,
    title: "SPAZIO CNO",
    address: "VIALE PORTO TORRES SNC, 51100 SASSARI (SS)",
    coordinates: { lat: 40.7259, lng: 8.5557 },
  },
  {
    id: 13,
    title: "Panorama-Pam Destinazione",
    address: "Z.S.CROCE SUPER ST.RM-NA, 30038 FORMIA (LT)",
    coordinates: { lat: 41.25, lng: 13.6 },
  },
  {
    id: 14,
    title: "Ce.Di.Gros",
    address: "VIA TORREVECCHIA, 1050, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 15,
    title: "Ce.Di.Gros",
    address: "VIA LANDUCCI TOSI ANG.V.RAVERA, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 16,
    title: "Ce.Di.Gros",
    address: "VIA TORREVECCHIA, 313 C/O, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 17,
    title: "Ce.Di.Gros",
    address: "VIA TERESA DE GUBERNATIS SNC, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 18,
    title: "Ce.Di.Gros",
    address: "VIA CASAL TIDEI, SNC, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 19,
    title: "Ce.Di.Gros",
    address: "VIA MILANO, 8, 00155 FIANO ROMANO (RM)",
    coordinates: { lat: 42.1667, lng: 12.6 },
  },
  {
    id: 20,
    title: "Ce.Di.Gros",
    address: "VIA FLAMINIA KM. 24,200, 00155 RIANO ROMANO (RM)",
    coordinates: { lat: 42.1, lng: 12.5167 },
  },
  {
    id: 21,
    title: "Retailpro",
    address: "VIA SCROFETA SNC, 81025 AVELLINO (AV)",
    coordinates: { lat: 40.9167, lng: 14.7833 },
  },
  {
    id: 22,
    title: "Retailpro",
    address: "VIA SAN LORENZO, 36, 81025 ATRIPALDA (AV)",
    coordinates: { lat: 40.9167, lng: 14.8333 },
  },
  {
    id: 23,
    title: "Ce.Di.Gros",
    address: "VIA TUSCOLANA KM 14,500, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 24,
    title: "Ce.Di.Gros",
    address: "VIA DEI CASTELLI ROMANI, 10/12, 00155 POMEZIA (RM)",
    coordinates: { lat: 41.6667, lng: 12.5 },
  },
  {
    id: 25,
    title: "Ce.Di.Gros",
    address: "VIA DI MACCHIA SAPONARA, 251, 00155 CASAL PALOCCO (RM)",
    coordinates: { lat: 41.75, lng: 12.4167 },
  },
  {
    id: 26,
    title: "Ce.Di.Gros",
    address: "VIA DELLE CILIEGIE, 100, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 27,
    title: "Ce.Di.Gros",
    address: "VIA ARMANDO VONA 20 C/O C.C. LE SORGENTI, 00155 FROSINONE (FR)",
    coordinates: { lat: 41.6333, lng: 13.35 },
  },
  {
    id: 28,
    title: "Panorama-Pam Destinazione",
    address: "VIA TIBURTINA, 757, 30038 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 29,
    title: "Panorama-Pam Destinazione",
    address: "VIA LAURENTINA, 865, 30038 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 30,
    title: "Ce.Di.Gros",
    address: "VIA DI TOR TRE TESTE, 222, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 31,
    title: "SPAZIO Conad P2",
    address: "VIA GIOVANNI BATTISTA VALENTE, 190, 06077 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 32,
    title: "Ipercoop Alleanza 3.0",
    address: "VIA PASUBIO, 144 INT. 40, 40050 PORTO D'ASCOLI (AP)",
    coordinates: { lat: 42.8833, lng: 13.8833 },
  },
  {
    id: 33,
    title: "Ipercoop Alleanza 3.0",
    address: "VIA 234 ZONA INDUSTRIALE, 40050 ASCOLI PICENO (AP)",
    coordinates: { lat: 42.85, lng: 13.5833 },
  },
  {
    id: 34,
    title: "Iperal",
    address: "VIA NAZIONALE, 29, 20123 CASTIONE ANDEVENNO (SO)",
    coordinates: { lat: 46.1667, lng: 9.8 },
  },
  {
    id: 35,
    title: "Iperal",
    address: "VIA NAZIONALE 55, 20123 PIANTEDO",
    coordinates: { lat: 46.1333, lng: 9.4333 },
  },
  {
    id: 36,
    title: "Iperal",
    address: "VIA NAZIONALE, 43, 20123 DARFO BOARIO TERME (BS)",
    coordinates: { lat: 45.8833, lng: 10.1833 },
  },
  {
    id: 37,
    title: "Iperal",
    address: "VIA PAPA GIOVANNI XXIII, 20123 CIVATE (LC)",
    coordinates: { lat: 45.8333, lng: 9.3333 },
  },
  {
    id: 38,
    title: "Ipercoop Alleanza 3.0",
    address: "S.S. LECCE BRINDISI KM. 1,9, 40050 SURBO (LE)",
    coordinates: { lat: 40.3833, lng: 18.1333 },
  },
  {
    id: 39,
    title: "Ipercoop Alleanza 3.0",
    address: "VIA PER MONTEMESOLA KM.10 LOC., 40050 TARANTO (TA)",
    coordinates: { lat: 40.4667, lng: 17.2333 },
  },
  {
    id: 40,
    title: "SPAZIO Conad CA",
    address: "S.S. 16 KM 962,700, 63030 CAVALLINO (LE)",
    coordinates: { lat: 40.3167, lng: 18.2 },
  },
  {
    id: 41,
    title: "SPAZIO Conad CA",
    address: "VIA PER SAN GIORGIO JONICO, KM 10, 63030 TARANTO (TA)",
    coordinates: { lat: 40.4667, lng: 17.2333 },
  },
  {
    id: 42,
    title: "Ipermercati Finiper",
    address: "P.ZZA CRISTOFORO COLOMBO, 3, 20129 SAVIGNANO SUL RUBICONE (FC)",
    coordinates: { lat: 44.0833, lng: 12.4 },
  },
  {
    id: 43,
    title: "SPAZIO Conad CIA",
    address: "VIA LEOPOLDO LUCCHI, 525, 47100 CESENA (FC)",
    coordinates: { lat: 44.1333, lng: 12.2333 },
  },
  {
    id: 44,
    title: "SPAZIO Conad CIA",
    address: "VIA NASSIRIYA, 20, 47100 RIMINI (RN)",
    coordinates: { lat: 44.05, lng: 12.5667 },
  },
  {
    id: 45,
    title: "SPAZIO Conad CIA",
    address: "PIAZZALE DELLA COOPERAZIONE, 2, 47100 FORLI' (FC)",
    coordinates: { lat: 44.2167, lng: 12.05 },
  },
  {
    id: 46,
    title: "SPAZIO Conad CIA",
    address: "VIA XXV OTTOBRE 4, 47100 FORLIMPOPOLI (FC)",
    coordinates: { lat: 44.1833, lng: 12.1333 },
  },
  {
    id: 47,
    title: "Ce.Di.Gros",
    address: "VIA ODERISI DA GUBBIO, 133/183, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 48,
    title: "Ce.Di.Gros",
    address: "VIALE DELL'OCEANO ATLANTICO 271, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 49,
    title: "Ce.Di.Gros",
    address: "VIA MASSIMO TROISI, 15, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 50,
    title: "Ce.Di.Gros",
    address: "VIA DI SANTA PETRONILLA, 10A-18A, 00155 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 51,
    title: "Ipercoop Distretto Nord Ovest",
    address: "VIA FONTEVIVO, 20090 LA SPEZIA (SP)",
    coordinates: { lat: 44.1, lng: 9.8167 },
  },
  {
    id: 52,
    title: "SPAZIO CNO",
    address: "VIA ARZELA' SNC, 51100 SANTO STEFANO MAGRA (SP)",
    coordinates: { lat: 44.15, lng: 9.9167 },
  },
  {
    id: 53,
    title: "SPAZIO Conad P2",
    address: "VIALE VILLAFRANCA, 23/27, 06077 TERNI (TR)",
    coordinates: { lat: 42.5667, lng: 12.65 },
  },
  {
    id: 54,
    title: "SPAZIO Conad P2",
    address: "VIA IGINO GARBINI 107, 06077 VITERBO (VT)",
    coordinates: { lat: 42.4167, lng: 12.1 },
  },
  {
    id: 55,
    title: "Conad Nor Ovest",
    address: "VIA AURELIA SUD, 51100 PIETRASANTA (LU)",
    coordinates: { lat: 43.95, lng: 10.2333 },
  },
  {
    id: 56,
    title: "SPAZIO Conad CIA",
    address: "VIA POSTUMIA OVEST, 76, 47100 SAN BIAGIO DI CALLALTA (TV)",
    coordinates: { lat: 45.6833, lng: 12.3833 },
  },
  {
    id: 57,
    title: "Ipermercati Finiper",
    address: "VIA DEI CARPANI, 21/A, 20129 CASTELFRANCO VENETO (TV)",
    coordinates: { lat: 45.6667, lng: 11.9333 },
  },
  {
    id: 58,
    title: "SPAZIO CNO",
    address: "VIA PORTANUOVA SNC, 51100 ORISTANO (OR)",
    coordinates: { lat: 39.9, lng: 8.5833 },
  },
  {
    id: 59,
    title: "Ipercoop Centro Italia",
    address: "VIALE DELL'OCEANO PACIFICO, 83, 57025 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 60,
    title: "SPAZIO Conad CA",
    address: "VIA SCATAGLINI, 6, 63030 ANCONA (AN)",
    coordinates: { lat: 43.6167, lng: 13.5167 },
  },
  {
    id: 61,
    title: "SPAZIO Conad CA",
    address: "VIA S. COSTANTINO, 98, 63030 CIVITANOVA MARCHE (MC)",
    coordinates: { lat: 43.3, lng: 13.7167 },
  },
  {
    id: 62,
    title: "Magazzini Gabrielli",
    address: "VIA DEL COMMERCIO, 52, 63100 ASCOLI PICENO (AP)",
    coordinates: { lat: 42.85, lng: 13.5833 },
  },
  {
    id: 63,
    title: "Magazzini Gabrielli",
    address: "LOCALITA' BRECCE 30, 63100 MATELICA (MC)",
    coordinates: { lat: 43.25, lng: 13.0167 },
  },
  {
    id: 64,
    title: "SPAZIO CNO",
    address: "VIA AROLA, 55 - CASAL DEL MARMO, 51100 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 65,
    title: "SPAZIO CNO",
    address: "VIA DEI SAMPIERI SNC, 51100 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 66,
    title: "Panorama-Pam Destinazione",
    address: "VIALE MALASPINA, 30038 FOSDINOVO (MS)",
    coordinates: { lat: 44.1333, lng: 10.0167 },
  },
  {
    id: 67,
    title: "Panorama-Pam Destinazione",
    address: "VIA FIRENZE-GOBETTI/P.ZA SARAGAT 10/2, 30038 LIVORNO (LI)",
    coordinates: { lat: 43.55, lng: 10.3167 },
  },
  {
    id: 68,
    title: "Pam supermercati-Pam Prossimit",
    address: "PIAZZA CARLO ROSSELLI, 30038 SIENA (SI)",
    coordinates: { lat: 43.3188, lng: 11.3308 },
  },
  {
    id: 69,
    title: "SPAZIO CNO",
    address: "LOC. SA MARINEDDA SN, 51100 OLBIA (OT)",
    coordinates: { lat: 40.9167, lng: 9.5 },
  },
  {
    id: 70,
    title: "SPAZIO Conad CA",
    address: "CONTRADA SANTA LIBERATA, 63030 ORTONA (CH)",
    coordinates: { lat: 42.35, lng: 14.4 },
  },
  {
    id: 71,
    title: "Arena",
    address: "VIA FILIPPO PECORAINO C/O C.C. FORUM, 94019 PALERMO (PA)",
    coordinates: { lat: 38.1167, lng: 13.3667 },
  },
  {
    id: 72,
    title: "Arena",
    address: "VIA UGO LA MALFA, 115, 94019 PALERMO (PA)",
    coordinates: { lat: 38.1167, lng: 13.3667 },
  },
  {
    id: 73,
    title: "Pam Club",
    address: "VIA MILANO 60, 30038 BORMIO (SO)",
    coordinates: { lat: 46.4667, lng: 10.3667 },
  },
  {
    id: 74,
    title: "Pac 2000",
    address: "VIA DELLA MAGLIANA 224, 06077 ROMA (RM)",
    coordinates: { lat: 41.9028, lng: 12.4964 },
  },
  {
    id: 75,
    title: "Pac 2000",
    address: "VIA DEI PIOPPI, 7, 06077 GUIDONIA (RM)",
    coordinates: { lat: 41.9833, lng: 12.7167 },
  },
  {
    id: 76,
    title: "Magazzini Gabrielli",
    address: "VIA GALILEO GALILEI, 371, 63100 GIULIANOVA (TE)",
    coordinates: { lat: 42.75, lng: 13.95 },
  },
  {
    id: 77,
    title: "Pac 2000",
    address: "VIALE ITALIA- ANG. VIA DEI VOLSCI, 78, 06077 PONTINIA (LT)",
    coordinates: { lat: 41.4, lng: 13.0333 },
  },
  {
    id: 78,
    title: "Pac 2000",
    address: "VIA DEL PARCO NAZIONALE, 06077 SABAUDIA (LT)",
    coordinates: { lat: 41.3, lng: 13.0167 },
  },
  {
    id: 79,
    title: "SPAZIO CNO",
    address: "VIA GRAMSCI, 1, 51100 SASSARI (SS)",
    coordinates: { lat: 40.7259, lng: 8.5557 },
  },
  {
    id: 80,
    title: "SPAZIO CNO",
    address: "VIALE PORTO TORRES SNC, 51100 SASSARI (SS)",
    coordinates: { lat: 40.7259, lng: 8.5557 },
  },
];
